
<!-- класс updateMe для обновляемого элемента-->

<!--
    Пример списка
    <span>Разработка и выпуск промоупаковки</span>
    <span>Разработка мобильного приложения с AR</span>
    <span>Поддержка блогеров<br> в YouTube и Instagram</span>
-->

<!--
в projects добавить поле status

для # Добавить новое поле в projects

для media
создать таблицу
в backend/img/ создать media с картинками

добавить таблицу контактов
-->
<template lang="pug">
    .caseUpdate(v-if="projects.length" :class='{updating:updating!==null||slideId!==null}')
        a.addNewProject.waves-effect.waves-light.btn.orange.darken-4(@click="addNewProject()") <i class="material-icons">add</i> Добавить проект
        a.dropProject.waves-effect.waves-light.btn.brown.darken-4(@click="dropProject()") <i class="material-icons">remove</i> Удалить проект
        main(ref="main")
            section.caseIntro
                .swiper-container.updateMe(data-updating="img")
                    .swiper-wrapper
                        .swiper-slide(v-for="pr in projects" :style="{backgroundImage: updatingField==='img'&&tempFile?'url('+tempFile+')':'url('+$rootPath+'/backend/img/projects/'+pr.img+')'}")
                            .yellowP
                            .text.updateMe(data-updating="title")
                                span(v-html="pr.title")
                            .digital
                                span.updateMe(data-updating="hashtag") {{pr.hashtag}}
                    .swiper-nav
                        .swiper-button-prev
                        .swiper-button-next

                a.publishProject.waves-effect.waves-light.btn.orange.darken-4( v-if="projects[activeProjectInd].status==='0'" @click="publishProject()") <i class="material-icons">publish</i>&nbsp;Опубликовать
                a.publishProject.waves-effect.waves-light.btn.orange.darken-4( v-if="projects[activeProjectInd].status==='1'" @click="unpublishProject()") <i class="material-icons">cancel</i>&nbsp;Не опубликовывать
            section.aboutTask
                .taskParams
                    .container
                        .param.updateMe(data-updating="task")
                            .title Задача
                            .strip
                            .text(v-html="projects[activeProjectInd].task")
                        .param.updateMe(data-updating="solution")
                            .title Решение
                            .strip
                            .text(v-html="projects[activeProjectInd].solution")
                        .param.updateMe(data-updating="mechanics")
                            .title Механика
                            .strip
                            .text(v-html="projects[activeProjectInd].mechanics")

                .slider
                    .swiper-container
                        .swiper-wrapper
                            .swiper-slide(v-for="slide in projects[activeProjectInd].slides")
                                .sliderContent(:style="{backgroundImage:slideId===slide.id&&tempFile?'url('+tempFile+')':'url('+$rootPath+'/backend/img/projects/slides/'+slide.img+')'}")
                                    .operations
                                        .updateSlide(@click='updateSlide(slide.id)' title='Изменить')
                                        .createSlide(@click='createSlide()' title='Создать')
                                        .deleteSlide(@click='deleteSlide(slide.id)' title='Удалить')
                .taskParams
                    .container
                        .param.updateMe(data-updating="results")
                            .title Результаты
                            .strip
                            .text(v-html="projects[activeProjectInd].results")
                        .param.updateMe(data-updating="tagline")
                            .title Награды
                            .strip
                            .text(v-html="projects[activeProjectInd].tagline")

            section.companies
                .container
                    .title
                        span Media about the project
                            .createMedia(@click="createMedia" title="Создать")
                    .slider
                        .swiper-container
                            .swiper-wrapper
                                a(:href="md.link" target="_blank").swiper-slide(v-for="md in media"
                                    :style="{backgroundImage: 'url('+$rootPath+'/backend/img/media/'+md.img+')'}")
                                    .dropMedia(@click.prevent='dropMedia(md.id)' title='Удалить')

            .updatingForm(ref="updatingForm" v-if="updating!==null")
                .row
                    form(@submit.prevent='')
                        .file-field.input-field.col.s12.formFile(v-if="updatingField==='img'")
                            .btn.orange.darken-2
                                span Изображение
                                input(type='file' @change="showFile($event.target.files[0])")
                                small.helper-text.invalid(v-if='formError') {{formError}}
                            .file-path-wrapper
                                input.file-path.validate(type='text')
                        .row.col.s12(v-else)
                            .input-field
                                textarea#title.materialize-textarea(data-length='120' v-model="updating[updatingField]")
                                label(for='title') {{updatingField[0].toUpperCase()+updatingField.slice(1)}}
                        .row
                            button.col.s5.btn.waves-effect.waves-light.orange.darken-2(type='submit' name='action' @click="cancleUpdate()") Отмена
                                i.material-icons.right cancel
                            button.col.s5.offset-s2.btn.waves-effect.waves-light.orange.darken-2(type='submit' name='action' @click="saveUpdate()") Сохранить
                                i.material-icons.right save

            .slidesForm(ref="slidesForm" v-if="slideId!==null")
                .row
                    form(@submit.prevent='')
                        .file-field.input-field.col.s12.formFile
                            .btn.orange.darken-2
                                span Изображение
                                input(type='file' @change="showFile($event.target.files[0])")
                                small.helper-text.invalid(v-if='formError') {{formError}}
                            .file-path-wrapper
                                input.file-path.validate(type='text')
                        .row
                            button.col.s5.btn.waves-effect.waves-light.orange.darken-2(type='submit' name='action' @click="cancleSlide()") Отмена
                                i.material-icons.right cancel
                            button.col.s5.offset-s2.btn.waves-effect.waves-light.orange.darken-2(type='submit' name='action' @click="saveSlide()") Сохранить
                                i.material-icons.right save


            .newMediaForm(ref="newMediaForm" v-if="createNewMedia")
                .row
                    form(@submit.prevent='')
                        .file-field.input-field.col.s12.formFile
                            .btn.orange.darken-2
                                span Изображение
                                input(type='file' @change="mediaImage = $event.target.files[0], mediaError = null")
                                small.helper-text.invalid(v-if='mediaError') {{mediaError}}
                            .file-path-wrapper
                                input.file-path.validate(type='text')
                            .input-field
                                textarea#linkA.materialize-textarea(data-length='120' v-model="mediaLink")
                                label(for='linkA') Ссылка
                        .row
                            button.col.s5.btn.waves-effect.waves-light.orange.darken-2(type='submit' name='action' @click="cancleMedia()") Отмена
                                i.material-icons.right cancel
                            button.col.s5.offset-s2.btn.waves-effect.waves-light.orange.darken-2(type='submit' name='action' @click="saveMedia()") Сохранить
                                i.material-icons.right save
</template>

<script>
    export default {
        name: "CaseUpdate",
        data: () => ({
            slidesProjectsSlider: null, // слайдер картинок проекта
            mediaSlider: null, // слайдер медиа
            projectsSlider: null,

            activeProjectInd: 0,
            projects: [],

            updating:null, // обновляемый проект
            updatingField:null, // Тип поля task, solution...
            updatingCopy:null,
            updatingType:'',
            formError: '',

            tempFile: null, //Временный файл для показа изображения
            loadedImg: null,

            slideAction:null, // Создаем или обновляем слайд
            slideId: null,

            isNewProject:null,



            // MEDIA
            media: [],
            mediaError: null, // ошибка при загрузке
            mediaImage:'', // изображение создаваемой медиа
            mediaLink:'', // ссылка создаваемой медиа
            createNewMedia: false,
        }),
        async mounted() {
            await this.fetchProjects();
            await this.fetchMedia();
            this.addUpdateBtns();
            setTimeout(() => {
                this.initSliders();
            })
        },
        watch:{
            updating(){
                this.projectsSlider.allowTouchMove = this.updating?false:true;
                this.slidesProjectsSlider.allowTouchMove = this.updating?false:true;
            },
            slideId(){
                this.projectsSlider.allowTouchMove = this.slideId?false:true;
                this.slidesProjectsSlider.allowTouchMove = this.slideId?false:true;
            },
            activeProjectInd(){
                setTimeout(()=>{
                    this.slidesProjectsSlider.destroy();
                    this.initImgsSlider();
                })
            }
        },
        methods: {
            async fetchProjects() {
                let data = this.compileFormData({action: 'fetchProjects',})
                let response = await fetch(this.$rootPath + '/backend/app/', {
                    method: 'POST',
                    body: data,
                });
                let responseData = await response.json();
                if (responseData && !responseData.error) {
                    this.projects = responseData.projects;
                    console.log(this.projects);
                } else {
                    console.log(responseData);
                }
            },
            async fetchMedia() {
                let data = new FormData;
                data.append('action','fetchMedia');
                let response = await fetch(this.$rootPath + '/backend/app/', {
                    method: 'POST',
                    body: data,
                });
                let responseData = await response.json();
                if (responseData && !responseData.error) {
                    this.media = responseData.media;
                    setTimeout(this.initMediaSlider)
                } else {
                    console.log(responseData);
                }
            },
            async saveUpdate(){
                let data = this.compileFormData({
                    action: 'updateProject',
                    id: this.updating.id,
                    field: this.updatingField,
                    content: this.updatingField === 'img' ? this.loadedImg: this.updating[this.updatingField]
                });
                let response = await fetch(this.$rootPath + '/backend/app/', {
                    method: 'POST',
                    body: data,
                });
                let responseData = await response.json();
                console.log(responseData);
                if (!responseData.error && responseData.success) {
                    if (responseData.newImgName) {
                        this.updating[this.updatingField] = responseData.newImgName;
                    }
                    this.clearForm();
                } else {
                    this.formError = responseData.message;
                    console.log(responseData);
                }
            },
            cancleUpdate() {
                this.projects[this.activeProjectInd] = JSON.parse(JSON.stringify(this.updatingCopy));
                this.clearForm();
            },


            updateSlide(id) {
                this.slideAction = 'update';
                this.slideId = id;
            },
            createSlide(){
                this.slideAction = 'create';
                let newId = +new Date();
                let slides = this.projects[this.activeProjectInd].slides;
                slides.push({projectId:this.activeProjectInd,img:'',id:newId});
                this.slideId = newId;
                setTimeout(() => {
                    this.slidesProjectsSlider.update();
                    this.slidesProjectsSlider.slideTo(slides.length, 1000);
                });
            },
            deleteSlide(id){
                this.saveDelete(id)
            },
            cancleSlide(){
                if (this.slideAction === 'create'){
                    let slides = this.projects[this.activeProjectInd].slides;
                    slides.pop();
                    setTimeout(() => {
                        this.slidesProjectsSlider.update();
                        this.slidesProjectsSlider.slideTo(slides.length, 1000);
                    });
                }
                this.clearForm();
            },

            // сохранить созданный слайд или обновить
            async saveSlide(){
                let data=null;
                if (this.slideAction==='update') {
                    data = this.compileFormData({
                        action: 'updateProjectSlide',
                        id: this.slideId,
                        content: this.loadedImg
                    });
                }else if(this.slideAction==='create'){
                    data = this.compileFormData({
                        action: 'createProjectSlide',
                        projectId: this.projects[this.activeProjectInd].id,
                        content: this.loadedImg
                    });
                }
                let response = await fetch(this.$rootPath + '/backend/app/', {
                    method: 'POST',
                    body: data,
                });
                let responseData = await response.json();
                if (!responseData.error && responseData.success) {
                    let slides = this.projects[this.activeProjectInd].slides;
                    if (this.slideAction==='update' && responseData.newImgName){
                        let slide = slides.find(el=>el.id==this.slideId);
                        if (slide){ slide.img = responseData.newImgName;}
                    } else if(this.slideAction==='create' && responseData.newImgName && responseData.id){
                        let slide = slides[slides.length-1];
                        if (slide){ slide.id = responseData.id;slide.img=responseData.newImgName}
                    }
                    this.clearForm();
                } else {
                    this.formError = responseData.message;
                    console.log(responseData);
                }
            },
            // удалить слайд
            async saveDelete(id){
                let slides = this.projects[this.activeProjectInd].slides;
                if (slides.length<2) return;
                let data = this.compileFormData({
                    action: 'deleteProjectSlide',
                    id: id
                })
                let response = await fetch(this.$rootPath + '/backend/app/', {
                    method: 'POST',
                    body: data,
                });
                let responseData = await response.json();
                if (!responseData.error && responseData.success) {
                    let slideIndex = slides.findIndex(el=>el.id===id);
                    slides.splice(slideIndex,1);
                    setTimeout(() => {
                        this.slidesProjectsSlider.update();
                    });
                } else {
                    this.formError = responseData.message;
                }
            },


            /*      MTDIA      */
            async createMedia(){
                this.createNewMedia = true;
            },
            cancleMedia(){
                this.mediaImage = '';
                this.mediaLink = '';
                this.createNewMedia = false;
            },
            async saveMedia(){
                this.mediaError = null;
                let fd = this.compileFormData({
                    action: 'createMedia',
                    img: this.mediaImage,
                    link: this.mediaLink
                });
                let response = await fetch(this.$rootPath + '/backend/app/', {
                    method: 'POST',
                    body: fd,
                });
                let responseData = await response.json();
                if (!responseData.error && responseData.success) {
                    this.createNewMedia = false;
                    await this.fetchMedia();
                    setTimeout(() => {
                        this.mediaSlider.update()
                    });
                    this.clearForm();
                } else {
                    this.mediaError = responseData.message;
                }
            },
            async dropMedia(id){
                let data = this.compileFormData({
                    action: 'dropMedia',
                    id: id,
                })
                let response = await fetch(this.$rootPath + '/backend/app/', {
                    method: 'POST',
                    body: data,
                });
                let responseData = await response.json();
                if (!responseData.error && responseData.success) {
                    let slideIndex = this.media.findIndex(el=>el.id===id);
                    this.media.splice(slideIndex,1);
                    setTimeout(() => {
                        this.mediaSlider.update()
                    });
                }
            },

            clearForm() {
                this.updating = null;
                this.updatingCopy = null;
                this.updatingType = null;
                this.tempFile = null;
                this.formError = '';
                this.loadedImg = null;
                this.slideAction = null;
                this.slideId = null;
                this.mediaImage = '';
                this.mediaLink = '';
            },
            compileFormData(data) {
                let formData = new FormData();
                for (let pr in data) {
                    formData.append(pr, data[pr]);
                }
                return formData;
            },
            showFile(f) {
                this.loadedImg = f;
                if (!f.type.match('image.*')) return;
                var fr = new FileReader();
                fr.onload = (() => (e) => {
                    this.tempFile = e.target.result;
                })(f);
                fr.readAsDataURL(f);
            },
            addUpdateBtns() {
                let updateMe = document.querySelectorAll('.updateMe');
                Array.prototype.forEach.call(updateMe, (el) => {
                    let btn = el.querySelector('.updateButton');
                    if (btn){
                        btn.parentElement.removeChild(btn);
                    }
                    let updateButton = document.createElement('div');
                    updateButton.classList.add('updateButton');
                    updateButton.addEventListener('click', this.updateClick);
                    el.appendChild(updateButton);
                })
            },
            updateClick(e) {
                let parent = e.target.closest('.updateMe');
                this.updating = this.projects[this.activeProjectInd];
                this.updatingField = parent.getAttribute('data-updating');
                this.updatingCopy = JSON.parse(JSON.stringify(this.updating));
                setTimeout(() => {
                    parent.appendChild(this.$refs.updatingForm);
                    M.updateTextFields();
                })
            },

            initSliders() {
                let self = this;
                this.projectsSlider = new Swiper('.caseIntro .swiper-container', {
                    slidesPerView: 1,
                    slideActiveClass: 'active',
                    centeredSlides: true,
                    grabCursor: true,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    effect: 'fade',
                    fadeEffect: {
                        crossFade: true
                    },
                    on: {
                        slideChange() {
                            self.activeProjectInd = this.realIndex;
                        }
                    },
                })
                this.initImgsSlider();
            },
            initMediaSlider(){
                this.mediaSlider = new Swiper ('.companies .swiper-container', {
                    slidesPerView: 7,
                    spaceBetween: 50,
                    slideActiveClass: 'active',
                    grabCursor: true,
                    breakpoints: {
                        1600: {
                            slidesPerView: 6,
                        },
                        1450: {
                            slidesPerView: 5.5,
                        },
                        768: {
                            slidesPerView: 2.3,
                        }
                    }
                });
            },
            initImgsSlider(){
                this.slidesProjectsSlider = new Swiper('.aboutTask .swiper-container', {
                    slidesPerView: 1.7,
                    spaceBetween: -80,
                    slideActiveClass: 'active',
                    centeredSlides: true,
                    grabCursor: true,
                    breakpoints: {
                        767: {
                            slidesPerView: 1.27,
                            spaceBetween: 5,
                        }
                    },
                });
            },



            async addNewProject(){
                let data = this.compileFormData({
                    action: 'addNewProject',
                })
                let response = await fetch(this.$rootPath + '/backend/app/', {
                    method: 'POST',
                    body: data,
                });
                let responseData = await response.json();
                console.log(responseData);
                if (!responseData.error && responseData.projects.length) {
                    this.projects.push(responseData.projects[0]);
                    setTimeout(() => {
                        this.projectsSlider.update();
                        this.projectsSlider.slideTo(this.projects.length, 1000);
                        this.addUpdateBtns();
                    });
                } else {
                    this.formError = responseData.message;
                }
            },

            // Опубликовать проект
            async publishProject(){
                let data = this.compileFormData({
                    action: 'updateProject',
                    id: this.projects[this.activeProjectInd].id,
                    field: 'status',
                    content: '1'
                })
                let response = await fetch(this.$rootPath + '/backend/app/', {
                    method: 'POST',
                    body: data,
                });
                let responseData = await response.json();
                if (!responseData.error) {
                    this.projects[this.activeProjectInd].status = '1';
                } else {
                    console.log('Error publist project');
                }
            },
            // Разопубликовать проект
            async unpublishProject(){
                let data = this.compileFormData({
                    action: 'updateProject',
                    id: this.projects[this.activeProjectInd].id,
                    field: 'status',
                    content: '0'
                })
                let response = await fetch(this.$rootPath + '/backend/app/', {
                    method: 'POST',
                    body: data,
                });
                let responseData = await response.json();
                if (!responseData.error) {
                    this.projects[this.activeProjectInd].status = '0';
                } else {
                    console.log('Error unpublish project');
                }
            },
            // Удалить проект
            async dropProject(){
                if (this.projects.length<2) return;
                let data = this.compileFormData({
                    action: 'dropProject',
                    id: this.projects[this.activeProjectInd].id,
                })
                let response = await fetch(this.$rootPath + '/backend/app/', {
                    method: 'POST',
                    body: data,
                });
                let responseData = await response.json();
                console.log(responseData);
                if (!responseData.error && responseData.success) {
                    this.projects.splice(this.activeProjectInd,1);
                    this.activeProjectInd--;
                    setTimeout(() => {
                        this.projectsSlider.update();
                        window.scrollTo({
                            top: 0,
                            behavior: 'smooth',
                        })
                    });
                } else {
                    this.formError = responseData.message;
                }
            }
        }
    }
</script>

<style lang="scss">
    @import "@/assets/scss/_variables.scss";
    @import "@/assets/scss/_functions.scss";

    .caseUpdate {
        &.updating{
            .updateButton{
                display: none;
            }
            .caseIntro{
                .swiper-button-prev,.swiper-button-next{
                    pointer-events: none!important;
                }
            }
        }
        .addNewProject{
            position: absolute !important;
            top: 1rem;
            left: 1%;
            z-index: 123123 !important;
            display: flex !important;
        }
        .dropProject{
            position: absolute !important;
            bottom: 2rem;
            right: 2.5rem;
            z-index: 123123 !important;
            display: flex !important;
        }
        section.caseIntro {
            height: 36.1vw;

            .swiper-container {
                height: 100%;
                & > .updateButton{
                    top: 1rem;
                    right: 2rem;
                    z-index: 50;
                }

                .swiper-wrapper {
                    height: 100%;

                    .swiper-slide {
                        position: relative;
                        height: 100%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        background: no-repeat center center /cover;
                        color: #fff;
                        pointer-events: all!important;
                        &.active{
                            z-index: 500;
                        }

                        .yellowP {
                            position: absolute;
                            top: 0;
                            left: 0;
                            bottom: 0;
                            right: 0;
                            pointer-events: none;
                            transform-origin: center;
                            background: url(../../assets/img/case/caseIntro_bg-yellow.svg) no-repeat 50% center /auto 85%;
                            z-index: -1;
                        }

                        .text {
                            margin-top: 1rem;
                            font: 800 to_rem(50px)/to_rem(47px) Geometria;
                            letter-spacing: to_rem(1.66px);
                            text-align: center;
                        }

                        .digital {
                            position: absolute;
                            bottom: 11%;
                            left: 0;
                            right: 4.6%;
                            font: 300 to_rem(18px)/to_rem(28px) Geometria;
                            text-align: center;
                            span{
                                padding: 0 3rem;
                            }
                        }
                    }
                }

                .swiper-nav {
                    position: absolute;
                    top: 0;
                    left: 50%;
                    transform: translateX(-50%);
                    width: 100%;
                    max-width: 78.8rem;
                    height: 100%;
                    margin: 0 auto;
                    z-index: 10;
                    pointer-events: none;

                    .swiper-button-prev, .swiper-button-next {
                        height: 2.4rem;
                        width: 7.7rem;
                        top: 56.3%;
                        background: url(../../assets/img/case/arrowYellow-right.png) no-repeat center center /contain;
                        pointer-events: all;

                        &:focus {
                            outline: none;
                        }
                    }

                    .swiper-button-prev {
                        left: 0;
                        transform: scale(-1, 1);
                    }

                    .swiper-button-next {
                        right: 0;
                    }
                }
            }

            .publishProject{
                position: absolute !important;
                top: 6rem;
                left: 1%;
                z-index: 123123 !important;
                display: flex !important;
            }
        }

        section.aboutTask {
            padding-top: 7.6rem;
            padding-bottom: 5rem;
            background: url(../../assets/img/case/caseTask_bg.png) no-repeat center  -9%/51% auto;

            .taskParams {
                .container {
                    display: flex;
                    flex-wrap: wrap;
                    max-width: 1120px;
                }

                .param {
                    width: 50%;

                    .title {
                        font: 700 to_rem(26px)/to_rem(26px) Geometria;
                        margin-bottom: 1.8rem;
                    }

                    .strip {
                        width: 4rem;
                        height: to_rem(5px);
                        margin-bottom: 2rem;
                        margin-left: -2px;
                        background: #ffc819;
                    }

                    .text {
                        min-height: 8.5rem;
                        font: 400 to_rem(18px)/to_rem(24px) Geometria;
                        span{
                            position: relative;
                            display: block;
                            &:after{
                                content: '';
                                position: absolute;
                                top: 0.6rem;
                                left: -1.8rem;
                                display: block;
                                height: to_rem(4px);
                                width: to_rem(4px);
                                border-radius: 50%;
                                background: #000;
                            }
                        }

                        p {
                            padding-bottom: 1.8rem;

                        }
                    }
                }
            }

            .slider {
                margin: 8% 0 6%;
                height: initial;

                .swiper-container {
                    overflow: visible;

                    .swiper-wrapper {
                        height: initial;

                        .swiper-slide {
                            transform: scale(0.6);
                            transform-origin: center 35%;
                            transition: .5s;

                            &:not(.active) {
                                opacity: 0.5;
                            }

                            &.active {
                                transform: scale(1);
                                box-shadow: 0 27px 56px rgba(0, 0, 0, 0.24);
                                .operations {
                                    opacity: 1;

                                    div {
                                        cursor: pointer;
                                    }
                                }
                            }
                            .operations {
                                position: absolute;
                                left: 101%;
                                top: 5%;
                                display: flex;
                                flex-direction: column;
                                opacity: 0;

                                div {
                                    height: 3rem;
                                    width: 3rem;
                                    margin-bottom: 1rem;
                                    background: no-repeat center center/contain;
                                }

                                .updateSlide {
                                    background-image: url(../../assets/img/admin/update-icon.png);
                                }

                                .createSlide {
                                    background-image: url(../../assets/img/admin/create-icon.png);
                                }

                                .deleteSlide {
                                    background-image: url(../../assets/img/admin/delete-icon.png);
                                }
                            }

                            .sliderContent {
                                padding-top: 56%;
                                background: no-repeat center center / cover;
                            }
                        }
                    }
                }
            }
        }

        section.companies{
            .container{
                max-width: 100%;
                width: 100%;
                padding: 0;
            }
            .title{
                margin: 8.7rem 0 3.6rem;
                text-align: center;
                font: 700 to_rem(26px)/to_rem(26px) Geometria;
                color: #585858;
                span{
                    position: relative;
                }
                .createMedia{
                    position: absolute;
                    top: 0;
                    left: 100%;
                    height: 3rem;
                    width: 3rem;
                    cursor: pointer;
                    display: none;
                    background: url(../../assets/img/admin/create-icon.png) no-repeat center center/contain;
                }
                &:hover .createMedia{
                    display: block;
                }
            }
            .slider{
                height: initial;
                margin-bottom: 5rem;
                padding: 3.7rem 0;
                background-color: #f4f4f4;

                .swiper-container{
                    .swiper-wrapper{
                        height: initial;
                        .swiper-slide{
                            position: relative;

                            height: 7.3vw;
                            max-height: 10rem;

                            background: no-repeat center center / contain;
                            .dropMedia{
                                position: absolute;
                                top: 0;
                                right: 0;
                                height: 3rem;
                                width: 3rem;
                                cursor: pointer;
                                display: none;
                                background: url(../../assets/img/admin/delete-icon.png) no-repeat center center/contain;
                            }
                            &:hover .dropMedia{
                                display: block;
                            }
                        }
                    }
                }
            }
        }

        .updateMe {
            position: relative;
            &:hover .updateButton {
                opacity: 1;
            }
            .updateButton {
                position: absolute;
                bottom: 100%;
                right: 0;
                height: 3rem;
                width: 3rem;
                background: url(../../assets/img/admin/update-icon.png) no-repeat center center / contain;
                opacity: 0;
                transition: .5s;
                cursor: pointer;
            }
        }

        .updatingForm, .slidesForm, .newMediaForm{
            position: fixed;
            top: 30%;
            left: 50%;
            transform: translateX(-50%);
            z-index: 200;
            width: 32rem;
            background: rgba(255, 255, 255, 0.8);
            &.stats {
                width: 37rem;
                form {
                    display: flex;
                    flex-direction: column;
                    .row {
                        width: 100%;
                        display: flex;
                        flex-wrap: wrap;
                        padding: 0;
                    }
                }
            }

            form {
                margin: 1rem 1rem 0;
                .formFile {
                    margin-bottom: 3rem;
                    padding: 0 !important;
                }
                small {
                    position: absolute !important;
                    color: red !important;
                    font-size: 1rem !important;
                    font-weight: 400;
                    cursor: url(./../../assets/img/cursor.png) 8 8, auto;
                }
                .row {
                    margin-bottom: 0 !important;
                }
                .input-field {
                    padding: 0;
                    textarea {
                        resize: vertical;
                    }
                    textarea:focus + label {
                        color: $color !important;
                    }
                    textarea:focus {
                        border-bottom: 1px solid $color !important;
                        box-shadow: 0 1px 0 0 $color !important;
                    }
                }
            }
        }
        @import "https://fonts.googleapis.com/icon?family=Material+Icons";
        @import "~materialize-css/sass/materialize";
    }

</style>
